import Shares from "./Shares";
import Payroll from "./Payroll";
export default {...Payroll,
...Shares,
};